import React, { Component } from 'react'
import ToggleSwitch from './ToggleSwitch.jsx';
import { round, ceil, floor } from 'mathjs';
import CollapseInfo from './CollapseInfo.jsx'
import VerticalRangeSlider from './RangeSliderVertical.js'
import RangeSlider from './RangeSlider.js'
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


export default class AssessSection extends Component {
    constructor(props) {
        super(props);

        this.state = {
            trialOptions: ['UR', 'R1', 'R2', 'R3'],
            trialOptionFullName: ['Un-resisted trial', 'Resisted load trial 1', 'Resisted load trial 2', 'Resisted load trial 3'],
            currentTrialSelection: 0,
            maxLoad: 200, // 200kg
            maxVel: 45,  //45 km/h
        }

        this.myinput = React.createRef();

        this.handleBodyWeightInputChange = this.handleBodyWeightInputChange.bind(this);
        this.calculateLoadPercentage = this.calculateLoadPercentage.bind(this);
        this.calculatePercentageVMax = this.calculatePercentageVMax.bind(this);
        this.calculateVelMPS = this.calculateVelMPS.bind(this);
        this.handleTogglePullPush = this.handleTogglePullPush.bind(this);
        this.handleToggleMetricImperial = this.handleToggleMetricImperial.bind(this);
        this.getCorrespondingNameOutput = this.getCorrespondingNameOutput.bind(this);
        this.handleControlledChangeVelMps = this.handleControlledChangeVelMps.bind(this);
        this.handleLoadSliderChange = this.handleLoadSliderChange.bind(this);
        this.handleLoadPercentageSliderChange = this.handleLoadPercentageSliderChange.bind(this);
        this.handleVelocitySliderChange = this.handleVelocitySliderChange.bind(this);
        this.handleVelocityMpsSliderChange = this.handleVelocityMpsSliderChange.bind(this);
        this.handleTrialSliderChange = this.handleTrialSliderChange.bind(this);
        this.getTrialSliderMarks = this.getTrialSliderMarks.bind(this);
        this.getRowStyleName = this.getRowStyleName.bind(this);
        this.renderWarning = this.renderWarning.bind(this);

    }

    handleFocus = (event) => event.target.select(); // won't need this if the table is no longer going to be the input

    handleTrialSliderChange(event, value) {
        //this.props.settingStateInParent(value, "currentTrialSelection");
        this.setState({ currentTrialSelection: value })
    }

    checkIfSliderDisabled() {
        const { currentTrialSelection } = this.state;
        if (currentTrialSelection === 0) {
            return (true)
        }
    }

    checkIfSliderTrackIsOff() {
        const { currentTrialSelection } = this.state;
        if (currentTrialSelection === 0) {
            return (false)
        }
        else {
            return ("normal")
        }
    }

    checkIfSliderLabelIsOn() {
        const { currentTrialSelection } = this.state;
        if (currentTrialSelection === 0) {
            return ("off")
        }
        else {
            return ("on")
        }
    }

    getTrialSliderMarks() {
        const { trialOptions } = this.state;
        const marks =
            [
                {
                    value: 0,
                    label: trialOptions[0],
                },
                {
                    value: 1,
                    label: trialOptions[1],
                },
                {
                    value: 2,
                    label: trialOptions[2],
                },
                {
                    value: 3,
                    label: trialOptions[3],
                },
            ];
        return (marks)
    }

    //Get respective variable values and names
    getVariableValue(column) {
        const variableName = this.getVariableName(column);
        const theseProps = this.props;
        const variableValue = theseProps[variableName];
        return (variableValue)
    }

    getVariableName(column) {
        const { currentTrialSelection } = this.state;
        var { variableName, prefix } = '';

        switch (column) {
            case 'LoadColumn':
                prefix = "resistedLoad";
                break;
            case 'LoadPercColumn':
                prefix = "resistedLoadPercentage";
                break;
            case 'VelocityColumn':
                prefix = "vel";
                break;
            case 'VelMPSColumn':
                prefix = "vMPS";
                break;
            default:
                break;
        }

        variableName = prefix + String(currentTrialSelection);
        return (variableName)
    }

    // Toggle switches
    handleTogglePullPush(pull) {
        const { bodyWeight, vMPS1, vMPS2, vMPS3, vMPS0 } = this.props;
        var { resistedLoadPercentage1, resistedLoadPercentage2, resistedLoadPercentage3, resistedLoad1,
            resistedLoad2, resistedLoad3, defaultActiveTrainingZone, trainingButtonCurrentClasses, trainingButtonCurrentColors,
            minSliderValue, maxSliderValue, currentSliderValue, explanation } = [];

        this.props.settingStateInParent(pull, "togglePullPush");

        // Check if pull is checked and set the load percentage and load states accordingly
        if (pull) {
            resistedLoadPercentage1 = 35;
            resistedLoadPercentage2 = 65;
            resistedLoadPercentage3 = 100;
            resistedLoad1 = this.props.calculateLoadFromPercentage(resistedLoadPercentage1, bodyWeight);
            resistedLoad2 = this.props.calculateLoadFromPercentage(resistedLoadPercentage2, bodyWeight);
            resistedLoad3 = this.props.calculateLoadFromPercentage(resistedLoadPercentage3, bodyWeight);
            defaultActiveTrainingZone = 'Technical Competency'; // for prescribe section
            trainingButtonCurrentClasses = ['trainingZoneButtonBlueFocus', 'trainingZoneButtonGreen', 'trainingZoneButtonYellow', 'trainingZoneButtonRed'];
            trainingButtonCurrentColors = ['#558bf0', '#555555', '#555555', '#555555'];

            minSliderValue = 0;
            maxSliderValue = 10;
            currentSliderValue = 5;
            explanation = "Add resistance with minimal disruption to sprint mechanics";
            //secondTickValue = 2.5;
            //thirdTickValue = 5;
            //fourthTickValue = 7.5;
        } else {
            resistedLoadPercentage1 = 35;
            resistedLoadPercentage2 = 65;
            resistedLoadPercentage3 = 100;
            resistedLoad1 = this.props.calculateLoadFromPercentage(resistedLoadPercentage1, bodyWeight);
            resistedLoad2 = this.props.calculateLoadFromPercentage(resistedLoadPercentage2, bodyWeight);
            resistedLoad3 = this.props.calculateLoadFromPercentage(resistedLoadPercentage3, bodyWeight);
            defaultActiveTrainingZone = 'Speed Strength'; // for prescribe section
            trainingButtonCurrentClasses = ['trainingZoneButtonBlue', 'trainingZoneButtonGreenFocus', 'trainingZoneButtonYellow', 'trainingZoneButtonRed'];
            trainingButtonCurrentColors = ['#555555', '#52de52', '#555555', '#555555'];

            minSliderValue = 10;
            maxSliderValue = 35;
            currentSliderValue = 22.5;
            //secondTickValue = 16.25;
            //thirdTickValue = 22.5;
            //fourthTickValue = 28.75;
            explanation = "Improve force production capability during transition to Vmax";

        }

        this.props.settingStateInParent(resistedLoadPercentage1, "resistedLoadPercentage1");
        this.props.settingStateInParent(resistedLoadPercentage2, "resistedLoadPercentage2");
        this.props.settingStateInParent(resistedLoadPercentage3, "resistedLoadPercentage3");
        this.props.settingStateInParent(resistedLoad1, "resistedLoad1");
        this.props.settingStateInParent(resistedLoad2, "resistedLoad2");
        this.props.settingStateInParent(resistedLoad3, "resistedLoad3");
        this.props.settingStateInParent(defaultActiveTrainingZone, "defaultActiveTrainingZone");
        this.props.settingStateInParent(trainingButtonCurrentClasses, "trainingButtonCurrentClasses");
        this.props.settingStateInParent(trainingButtonCurrentColors, "trainingButtonCurrentColors");
        this.props.settingStateInParent(minSliderValue, "minSliderValue");
        this.props.settingStateInParent(maxSliderValue, "maxSliderValue");
        this.props.settingStateInParent(currentSliderValue, "currentSliderValue");
        this.props.settingStateInParent(explanation, "explanation");

        //this.props.settingStateInParent(secondTickValue, "secondTickValue");
        //this.props.settingStateInParent(thirdTickValue, "thirdTickValue");
        //this.props.settingStateInParent(fourthTickValue, "fourthTickValue");

        this.props.calculateSlopeAndIntercept(vMPS0, vMPS1, vMPS2, vMPS3, resistedLoad1, resistedLoad2, resistedLoad3);
    }

    handleToggleMetricImperial(metric) {
        var bodyWeightValue = this.props.bodyWeight;
        var { velocityStringUnits, bodyWeightUnitString, vMPS0, vMPS1, vMPS2, vMPS3, resistedLoad1, resistedLoad2, resistedLoad3 } = [];
        const { resistedLoadPercentage1, resistedLoadPercentage2, resistedLoadPercentage3, vel0, vel1, vel2, vel3 } = this.props;
        var { maxLoad, maxVel } = [];

        this.props.settingStateInParent(metric, "toggleMetImp");

        // Check if metric is checked and set the unit states accordingly
        if (metric) {

            velocityStringUnits = '(kph)';
            bodyWeightUnitString = '(kg)';
            bodyWeightValue = bodyWeightValue / 2.20462;
            maxLoad = 440 / 2.20462;
            maxVel = 45;

        } else {

            velocityStringUnits = '(mph)';
            bodyWeightUnitString = '(lbs)';
            bodyWeightValue = bodyWeightValue * 2.20462;
            maxLoad = 200 * 2.20462;
            maxVel = 28;
        }

        this.props.settingStateInParent(velocityStringUnits, "velocityStringUnits");
        this.props.settingStateInParent(bodyWeightUnitString, "bodyWeightUnitString");
        this.setState({ maxLoad: ceil(maxLoad) })
        this.setState({ maxVel: ceil(maxVel) })

        this.props.settingStateInParent(bodyWeightValue, "bodyWeight");

        // caluclate resisted load and then set it in the parent state
        resistedLoad1 = this.props.calculateLoadFromPercentage(resistedLoadPercentage1, bodyWeightValue);
        resistedLoad2 = this.props.calculateLoadFromPercentage(resistedLoadPercentage2, bodyWeightValue);
        resistedLoad3 = this.props.calculateLoadFromPercentage(resistedLoadPercentage3, bodyWeightValue);

        this.props.settingStateInParent(resistedLoad1, "resistedLoad1");
        this.props.settingStateInParent(resistedLoad2, "resistedLoad2");
        this.props.settingStateInParent(resistedLoad3, "resistedLoad3");

        // Calculate the velocity in mps and then set it in the parent (within the handleChangeVMaxMps) // is this still necessary if it is from a slider? 
        vMPS0 = this.handleControlledChangeVelMps('vMPS0', vel0, metric);
        vMPS1 = this.handleControlledChangeVelMps('vMPS1', vel1, metric)
        vMPS2 = this.handleControlledChangeVelMps('vMPS2', vel2, metric)
        vMPS3 = this.handleControlledChangeVelMps('vMPS3', vel3, metric)

        this.props.calculateSlopeAndIntercept(vMPS0, vMPS1, vMPS2, vMPS3, resistedLoad1, resistedLoad2, resistedLoad3);

    }

    handleVelocityMpsSliderChange = name => (e, value) => {
        const { resistedLoad1, resistedLoad2, resistedLoad3 } = this.props;
        var { vMPS1, vMPS2, vMPS3, vMPS0 } = this.props;
        const calculatedValueVelKphOrMph = Number(this.calculateVelKphOrMph(value));

        this.props.settingStateInParent(Number(value), name); //  sets the velocity value (mps) state of parent
        this.props.settingStateInParent(calculatedValueVelKphOrMph, this.getCorrespondingNameOutput(name)); // sets the velocity value in kph/mph in state (of parent)

        // update whichever velocity in mps was pulled in from props, because the new value set in states will not reflect till the next rerender
        switch (name) {
            case 'vMPS0':
                vMPS0 = Number(value);
                break;
            case 'vMPS1':
                vMPS1 = Number(value);
                break;
            case 'vMPS2':
                vMPS2 = Number(value);
                break;
            case 'vMPS3':
                vMPS3 = Number(value);
                break;
            default:
                break;
        }

        this.props.calculateSlopeAndIntercept(vMPS0, vMPS1, vMPS2, vMPS3, resistedLoad1, resistedLoad2, resistedLoad3);
    }

    handleVelocitySliderChange = name => (e, value) => {
        const { resistedLoad1, resistedLoad2, resistedLoad3 } = this.props;
        var { vMPS1, vMPS2, vMPS3, vMPS0 } = this.props;
        const calculatedValue = Number(this.calculateVelMPS(value));

        this.props.settingStateInParent(Number(value), name); //  sets the velocity value (kph or mph) state of parent
        this.props.settingStateInParent(calculatedValue, this.getCorrespondingNameOutput(name)); // sets the velocity value in mps in state (of parent)

        // update whichever velocity in mps was pulled in from props, because the new value set in states will not reflect till the next rerender

        switch (name) {
            case 'vel0':
                vMPS0 = calculatedValue;
                break;
            case 'vel1':
                vMPS1 = calculatedValue;
                break;
            case 'vel2':
                vMPS2 = calculatedValue;
                break;
            case 'vel3':
                vMPS3 = calculatedValue;
                break;
            default:
                break;
        }

        this.props.calculateSlopeAndIntercept(vMPS0, vMPS1, vMPS2, vMPS3, resistedLoad1, resistedLoad2, resistedLoad3);
    }

    handleControlledChangeVelMps(name, value, toggleUnitFlag) {
        var velocityMPS = [];

        if (toggleUnitFlag) {
            velocityMPS = Number(value) / 3.6;
        } else {
            velocityMPS = Number(value) / 2.237;
        }

        this.props.settingStateInParent(velocityMPS, name);

        return velocityMPS;
    }

    getCorrespondingNameOutput(name) {
        switch (name) {
            case 'vel0':
                return 'vMPS0';
            case 'vel1':
                return 'vMPS1';
            case 'vel2':
                return 'vMPS2';
            case 'vel3':
                return 'vMPS3';
            case 'vMPS0':
                return 'vel0';
            case 'vMPS1':
                return 'vel1';
            case 'vMPS2':
                return 'vel2';
            case 'vMPS3':
                return 'vel3';
            case 'resistedLoad0':
                return 'resistedLoadPercentage0';
            case 'resistedLoad1':
                return 'resistedLoadPercentage1';
            case 'resistedLoad2':
                return 'resistedLoadPercentage2';
            case 'resistedLoad3':
                return 'resistedLoadPercentage3';
            case 'resistedLoadPercentage0':
                return 'resistedLoad0';
            case 'resistedLoadPercentage1':
                return 'resistedLoad1';
            case 'resistedLoadPercentage2':
                return 'resistedLoad2';
            case 'resistedLoadPercentage3':
                return 'resistedLoad3';
            default:
                return 'unrecognized value';
        }
    }

    handleBodyWeightInputChange(event) {
        const { name, value } = event.target;
        const { resistedLoadPercentage1, resistedLoadPercentage2, resistedLoadPercentage3, vMPS1, vMPS2, vMPS3, vMPS0 } = this.props;
        var { resistedLoad1, resistedLoad2, resistedLoad3 } = [];

        this.props.settingStateInParent(Number(value), name); // set body weight state in parent component

        resistedLoad1 = this.props.calculateLoadFromPercentage(resistedLoadPercentage1, value);
        resistedLoad2 = this.props.calculateLoadFromPercentage(resistedLoadPercentage2, value);
        resistedLoad3 = this.props.calculateLoadFromPercentage(resistedLoadPercentage3, value);

        this.props.settingStateInParent(Number(resistedLoad1), 'resistedLoad1');
        this.props.settingStateInParent(Number(resistedLoad2), 'resistedLoad2');
        this.props.settingStateInParent(Number(resistedLoad3), 'resistedLoad3');

        this.props.calculateSlopeAndIntercept(vMPS0, vMPS1, vMPS2, vMPS3, resistedLoad1, resistedLoad2, resistedLoad3);
    }

    handleLoadSliderChange = name => (e, value) => {
        const bodyWeight = this.props.bodyWeight;
        var { resistedLoad1, resistedLoad2, resistedLoad3, vMPS1, vMPS2, vMPS3, vMPS0 } = this.props;
        this.props.settingStateInParent(Number(value), name);// set the resisted load value
        this.props.settingStateInParent(Number(this.calculateLoadPercentage(value, bodyWeight)), this.getCorrespondingNameOutput(name));// set the percentage body weight

        switch (name) {
            case 'resistedLoad1':
                resistedLoad1 = Number(value);
                break;
            case 'resistedLoad2':
                resistedLoad2 = Number(value);
                break;
            case 'resistedLoad3':
                resistedLoad3 = Number(value);
                break;
            default:
                break;
        }

        this.props.calculateSlopeAndIntercept(vMPS0, vMPS1, vMPS2, vMPS3, resistedLoad1, resistedLoad2, resistedLoad3);

    }

    handleLoadPercentageSliderChange = name => (e, value) => {
        const { bodyWeight, vMPS1, vMPS2, vMPS3, vMPS0 } = this.props;
        var { resistedLoad1, resistedLoad2, resistedLoad3 } = this.props;

        this.props.settingStateInParent(Number(value), name);// sets percentage load
        this.props.settingStateInParent(Number(this.props.calculateLoadFromPercentage(value, bodyWeight)), [this.getCorrespondingNameOutput(name)]);// sets load from percentage


        const calculatedValue = Number(this.props.calculateLoadFromPercentage(value, bodyWeight));

        switch (this.getCorrespondingNameOutput(name)) {
            case 'resistedLoad1':
                resistedLoad1 = calculatedValue;
                break;
            case 'resistedLoad2':
                resistedLoad2 = calculatedValue;
                break;
            case 'resistedLoad3':
                resistedLoad3 = calculatedValue;
                break;
            default:
                break;
        }

        this.props.calculateSlopeAndIntercept(vMPS0, vMPS1, vMPS2, vMPS3, resistedLoad1, resistedLoad2, resistedLoad3);

    }

    calculateLoadPercentage = (load, bodyWeight) => {
        const loadPercentage = load / bodyWeight * 100;
        return loadPercentage;

    }

    calculateVelMPS = (value) => {
        var vMax_mps = [];
        const metric = this.props.toggleMetImp;
        if (metric) {
            vMax_mps = value / 3.6;
        } else {
            vMax_mps = value / 2.237;
        }
        return Number(vMax_mps);
    }

    calculateVelKphOrMph = (value) => {
        var vel = [];
        const metric = this.props.toggleMetImp;
        if (metric) {
            vel = value * 3.6;
        } else {
            vel = value * 2.237;
        }
        return Number(vel);
    }

    calculatePercentageVMax = (value) => {
        const vel0 = this.props.vel0;
        const velPercentage = value / vel0 * 100;
        return Number(velPercentage);
    }

    getRowStyleName(currentTrial) {
        const { currentTrialSelection, trialOptions } = this.state;

        if (trialOptions[currentTrialSelection] === currentTrial) {
            return ("trInsetFocused")
        }
        else {
            return ("trInset")
        }
    }

    renderWarning() {
        const { rsquaredValue } = this.props;
        if (rsquaredValue < 0.8 && this.props.vMPS0 !== 0 && this.props.vMPS1 !== 0 && this.props.vMPS2 !== 0 && this.props.vMPS3 !== 0) {
            return (
                <div className="warningContainer">
                    <FontAwesomeIcon icon={faExclamationTriangle} />
                    <p>Warning, the r-squared value is below 0.8, ensure your inputs are correct for realistic results</p>
                </div>

            )
        }
    }

    //toDecimal(number) {
    //    const formatter = new Intl.NumberFormat('de-DE', {
    //        style: "decimal",
    //        maximumSignificantDigits: 3
    //    })
    //    return formatter.format(number);
    // }

    //isNumber(event) {
    //    var keycode = event.keycode;
    //    if (keycode > 48 && keycode < 57) {
    //        return true;
    //    }
    //    if (keycode  === 188) {
    //        return true;
    //        console.log('it worked')
    //    }
    //    return false;

    //}

    render() {
        const { togglePullPush, toggleMetImp, bodyWeight, resistedLoadPercentage0, resistedLoadPercentage1, resistedLoadPercentage2, resistedLoadPercentage3, velocityStringUnits, bodyWeightUnitString, vel0, vel1, vel2, vel3, vMPS0, slopeValue, interceptValue, rsquaredValue } = this.props;
        const { currentTrialSelection, trialOptionFullName, maxLoad, maxVel } = this.state;
        return (
            <div >
                <h3 className="heading3">Step 2 - Assess: Create a load-velocity profile</h3>
                <div className="bodyWeightAndTogglesContainer">
                    <div className="bodyWeightContainer">
                        <label>{"Athlete Weight " + bodyWeightUnitString + ":"}</label>
                        <input
                            className="inputStyleBodyWeight"
                            name="bodyWeight"
                            type="number"
                            //inputmode="decimal"
                            //lang="en-150"
                            //pattern="^[0�9]+.[0-9]"
                            //onKeyPress={this.isNumber}
                            //type="number"
                            min={0}
                            max={450}
                            //step={0.01}
                            //value={this.toDecimal(round(bodyWeight, 2))}
                            value={round(bodyWeight, 2)}
                            onChange={this.handleBodyWeightInputChange}
                            onFocus={this.handleFocus}
                        />
                    </div>
                    <div className="toggleSwitchesContainer">
                        <ToggleSwitch
                            Name="togglePushPull"
                            datayes="Pull"
                            datano="Push"
                            checked={togglePullPush}
                            callBack={this.handleTogglePullPush}
                        />
                        <ToggleSwitch
                            Name="toggleMetImp"
                            datayes="Metric"
                            datano="Imperial"
                            checked={toggleMetImp}
                            callBack={this.handleToggleMetricImperial} />
                    </div>
                </div>
                <div >
                    <h3 className="heading3">Use slider to select sprint trial</h3>
                </div>
                <p className="currentTrial">
                    {trialOptionFullName[currentTrialSelection]}
                    < RangeSlider
                        min={0}
                        max={3}
                        value={this.state.currentTrialSelection}
                        onChange={this.handleTrialSliderChange}
                        valueLabelDisplay={'off'}
                        step={null}
                        marks={this.getTrialSliderMarks()}
                        track={false} >
                    </RangeSlider>
                </p>
                < div className="VerticalSliderContainer">
                    < VerticalRangeSlider
                        labelOfSlider={'Sled Load'}
                        labelOfSliderUnit={bodyWeightUnitString}
                        min={0}
                        max={maxLoad}
                        // note this slider value is retrieved slightly different due to another push/pull toggle controlling this section. 
                        // We need the load calculated from the set percentage body weight guidelines and the body weight (Cannot hardcode these because the person could have changed the body weight)
                        value={Number(this.props.calculateLoadFromPercentage((this.getVariableValue("LoadPercColumn")), bodyWeight))}
                        onChange={this.handleLoadSliderChange(this.getVariableName("LoadColumn"))}
                        valueLabelDisplay={this.checkIfSliderLabelIsOn()}
                        step={1}
                        disabled={this.checkIfSliderDisabled()}
                        track={this.checkIfSliderTrackIsOff()}
                    > </VerticalRangeSlider>
                    < VerticalRangeSlider
                        labelOfSlider={'Sled Load'}
                        labelOfSliderUnit={'(% BW)'}
                        min={0}
                        max={floor(this.calculateLoadPercentage(maxLoad, bodyWeight))}
                        value={this.getVariableValue("LoadPercColumn")}
                        onChange={this.handleLoadPercentageSliderChange(this.getVariableName("LoadPercColumn"))}
                        valueLabelDisplay={this.checkIfSliderLabelIsOn()}
                        step={1}
                        disabled={this.checkIfSliderDisabled()}
                        track={this.checkIfSliderTrackIsOff()}
                    >
                    </VerticalRangeSlider>
                    < VerticalRangeSlider
                        labelOfSlider={'V Max'}
                        labelOfSliderUnit={velocityStringUnits}
                        min={0}
                        max={maxVel}
                        value={this.getVariableValue("VelocityColumn")}
                        onChange={this.handleVelocitySliderChange(this.getVariableName("VelocityColumn"))}
                        valueLabelDisplay={"on"}
                        step={0.1}
                        disabled={false}
                        track={"normal"}
                    > </VerticalRangeSlider>
                    < VerticalRangeSlider
                        labelOfSlider={'V Max'}
                        labelOfSliderUnit={'(m/s)'}
                        min={0}
                        max={ceil(this.calculateVelMPS(maxVel))}
                        value={this.getVariableValue("VelMPSColumn")}
                        onChange={this.handleVelocityMpsSliderChange(this.getVariableName("VelMPSColumn"))}
                        valueLabelDisplay={"on"}
                        step={0.1}
                        disabled={false}
                        track={"normal"}
                    > </VerticalRangeSlider>
                </div>
                <form className="assessForms">
                    <table>
                        <tbody>
                            <tr className={this.getRowStyleName("UR")} >
                                <td style={{ borderTopLeftRadius: "25px", borderBottomLeftRadius: "25px" }}>{Number(this.props.calculateLoadFromPercentage(resistedLoadPercentage0, bodyWeight))}</td>
                                <td>{Number(resistedLoadPercentage0)}</td>
                                <td>{round(vel0, 2)}</td>
                                <td style={{ borderTopRightRadius: "25px", borderBottomRightRadius: "25px" }}>{Number(vMPS0).toFixed(2)}</td>
                            </tr>
                            <tr className={this.getRowStyleName("R1")}>
                                <td style={{ borderTopLeftRadius: "25px", borderBottomLeftRadius: "25px" }}>{round(this.props.calculateLoadFromPercentage(resistedLoadPercentage1, bodyWeight), 2)}</td>
                                <td>{round(resistedLoadPercentage1, 2)}</td>
                                <td>{round(vel1, 2)}</td>
                                <td style={{ borderTopRightRadius: "25px", borderBottomRightRadius: "25px" }}>{this.calculateVelMPS(vel1).toFixed(2)}</td>
                            </tr>
                            <tr className={this.getRowStyleName("R2")}>
                                <td style={{ borderTopLeftRadius: "25px", borderBottomLeftRadius: "25px" }}>{round(this.props.calculateLoadFromPercentage(resistedLoadPercentage2, bodyWeight), 2)}</td>
                                <td>{round(resistedLoadPercentage2, 2)}</td>
                                <td>{round(vel2, 2)}</td>
                                <td style={{ borderTopRightRadius: "25px", borderBottomRightRadius: "25px" }}>{this.calculateVelMPS(vel2).toFixed(2)}</td>
                            </tr>
                            <tr className={this.getRowStyleName("R3")}>
                                <td style={{ borderTopLeftRadius: "25px", borderBottomLeftRadius: "25px" }}>{round(this.props.calculateLoadFromPercentage(resistedLoadPercentage3, bodyWeight), 2)}</td>
                                <td>{round(resistedLoadPercentage3, 2)}</td>
                                <td>{round(vel3, 2)}</td>
                                <td style={{ borderTopRightRadius: "25px", borderBottomRightRadius: "25px" }}>{this.calculateVelMPS(vel3).toFixed(2)}</td>
                            </tr>
                        </tbody>
                    </table>
                </form>
                <table style={{
                    width: '20%',
                }}>
                </table>
                {this.renderWarning()}
                <CollapseInfo classCollapseInfoContainer="containerMoreInfo" classCollapseInfoContent="contentMoreInfo" classCollapseHeader="headerMoreInfo" titleFalse="See less:" titleTrue="See more:" Type="moreInfo">
                    <p>{"Slope (gradient): " + Number(slopeValue).toFixed(3)}</p>
                    <p>{"Y-Intercept: " + Number(interceptValue).toFixed(3)}</p>
                    <p>{"R-squared: " + Number(rsquaredValue).toFixed(3)}</p>
                </CollapseInfo>
            </div>
        );
    }
}

                    //< label className="inputStyleBodyWeight"> Load (kg) </label>
                    //< RangeSlider> </RangeSlider>
                    //< label className="inputStyleBodyWeight"> Percentage BodyWeight (%) </label>
                    //< RangeSlider> </RangeSlider>